import type {Ref, InjectionKey, ComputedRef} from "vue";
import {inject, provide, ref, computed} from "vue";

export interface ScreenSize {
	width: number;
	height: number;
}

export const layoutWidthKey = Symbol() as InjectionKey<Ref<number>>;
export const layoutHeightKey = Symbol() as InjectionKey<Ref<number>>;
export const layoutSizeKey = Symbol() as InjectionKey<ComputedRef<ScreenSize>>;

const screenWidth = ref<number>(document.documentElement.clientWidth);  // window.innerWidth minus scrollbars
const screenHeight = ref<number>(document.documentElement.clientHeight);
const screenSize = computed<ScreenSize>(() => {
	return { width: screenWidth.value, height: screenHeight.value };
});

window.addEventListener('resize', () => {
    screenWidth.value = document.documentElement.clientWidth;
	screenHeight.value = document.documentElement.clientHeight;
});

export function injectLayoutWidth():Ref<number> {
    return inject(layoutWidthKey, screenWidth);
}

export function injectLayoutHeight():Ref<number> {
    return inject(layoutHeightKey, screenHeight);
}

export function injectLayoutSize():ComputedRef<ScreenSize> {
    return inject(layoutSizeKey, screenSize);
}

export function provideLayoutWidth(width: Ref<number>) {
    provide(layoutWidthKey, width);
}

export function divideWidth(parentWidth:number, ...split:string[]):number[] {
    const result:number[] = [];
    let remains = parentWidth;
    let frIdxs:number[] = [];
    let frTotal:number = 0;
    // Calculate fixed
    for (let i = 0; i < split.length; i++) {
        const sp = split[i];
        if (sp.endsWith("px")) {
            result[i] = parseFloat(sp.substring(0, sp.length - 2));
            remains -= result[i];
        } else if (sp.endsWith("%")) {
            result[i] = parentWidth * (parseFloat(sp.substring(0, sp.length - 1))/100);
            remains -= result[i];
        } else if (sp.endsWith("fr")) {
            const val = parseInt(sp.substring(0, sp.length - 2));
            frTotal += val;
            frIdxs.push(i);
        } else throw new Error("Unsupported divide width value " + sp);
    }

    // Split remaining width
    if (frTotal > 0) {
        for (let i of frIdxs) {
            const sp = split[i];
            const val = parseInt(sp.substring(0, sp.length - 2));
            const ratio = val / frTotal;
            result[i] = ratio * remains;
        }
    }
    return result;
}